import { CategoryTypeEnum } from '@shared/api/models';
import { QuestionsType } from '@shared/api/rest/survey';
import clsx from 'clsx';

interface AnswersType {
  question: QuestionsType;
  value: any;
  onChange: any;
}

export const Answers = (props: AnswersType) => {
  const handleChange = (itemId: string) => {
    if (isRadio) {
      props.onChange(props.value === itemId ? null : itemId);
    } else if (isCheckbox) {
      if (props.question.MultipleAnswers) {
        const currentValue = Array.isArray(props.value) ? props.value : [];
        const newValue = currentValue.includes(itemId) ? currentValue.filter((id) => id !== itemId) : [...currentValue, itemId];
        props.onChange(newValue.length > 0 ? newValue : null);
      } else {
        props.onChange(props.value === itemId ? null : itemId);
      }
    }
  };

  const isRadio = props.question.CategoryType === CategoryTypeEnum.Radio;
  const isCheckbox = props.question.CategoryType === CategoryTypeEnum.Checkbox;

  return (
    <div
      className={clsx('flex flex-wrap mt-4 gap-4', {
        'sm:gap-20!': props?.question?.Answers?.length < 3,
      })}
    >
      {props.question.Answers.map((item) => {
        const isChecked = isRadio
          ? props.value === item.Id
          : isCheckbox
            ? props.question.MultipleAnswers
              ? Array.isArray(props.value) && props.value.includes(item.Id)
              : props.value === item.Id
            : false;

        return (
          <label
            key={item.Id}
            className={clsx('flex items-center cursor-pointer select-none', {
              'w-[calc(50%-8px)] sm:w-[calc(33.333%-10.666px)] max-md:w-full lg:w-[calc(20%-12.8px)]': isCheckbox,
              'mr-4 mb-4 order-first': isRadio,
              'w-max!': props?.question?.Answers?.length < 3,
            })}
          >
            {isCheckbox && (
              <div className='flex items-center w-full'>
                <div className='relative flex items-center h-5 mr-2'>
                  <input
                    type='checkbox'
                    checked={isChecked}
                    onChange={() => handleChange(item.Id)}
                    className='appearance-none w-5 h-5 bg-white border-2 border-[#e4be96] cursor-pointer flex-shrink-0 hover:shadow-[0_0_0_2px_rgba(46,105,255,0.5)] hover:rounded-[2px] peer focus:shadow-[0_0_0_3px_rgba(46,105,255,0.5)] focus:rounded-[2px]'
                  />
                  <div className="absolute left-1 top-1 w-4 h-4 pointer-events-none after:content-[''] after:absolute after:bg-none after:border-b-[3px] after:border-l-[3px] after:border-[#e4be96] after:inline-block after:rotate-[-45deg] after:h-[9px] after:w-[18px] after:top-[-5] after:left-0.5 after:rounded-[2px] after:opacity-0 peer-checked:after:opacity-100" />
                </div>
                <div
                  className={clsx('text-base font-normal text-left whitespace-normal', {
                    'whitespace-nowrap': props?.question?.Answers?.length < 3,
                  })}
                >
                  {item.Name}
                </div>
              </div>
            )}
            {isRadio && (
              <div className='relative flex items-center'>
                <input type='radio' checked={isChecked} onChange={() => handleChange(item.Id)} className='sr-only peer' />
                <div
                  className={clsx(
                    'w-10 h-10 rounded-full border flex items-center justify-center transition-colors hover:shadow-[0_0_0_2px_rgba(173,216,230,0.8)] hover:bg-[#f2ebd3]',
                    {
                      'border-gray-300': !isChecked,
                      'border-[#b49e58] bg-[#dbcea2]': isChecked,
                    },
                  )}
                >
                  <span
                    className={clsx('text-xs font-medium !text-black', {
                      'text-transparent': !isChecked,
                      '!text-white': isChecked,
                    })}
                  >
                    {item.Name}
                  </span>
                </div>
              </div>
            )}
          </label>
        );
      })}
    </div>
  );
};
